import { render, staticRenderFns } from "./ObjectImage.vue?vue&type=template&id=046b21d8&"
import script from "./ObjectImage.vue?vue&type=script&lang=js&"
export * from "./ObjectImage.vue?vue&type=script&lang=js&"
import style0 from "./ObjectImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports